import { render, staticRenderFns } from "./ForgotPasswordDialog.vue?vue&type=template&id=758abb04&"
import script from "./ForgotPasswordDialog.vue?vue&type=script&lang=ts&"
export * from "./ForgotPasswordDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/BUILD/Desktop/vsts-agent-win-x64-2.131.0/_work/13/s/DiapasonWeb/Client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VSpacer})
